import React, {Component} from 'react';
import './simple.css';
import Drawer from 'rmc-drawer';
import {mailFolderListItems} from './tileData';

class HeaderDrawer extends Component {
    onOpenChange = (open) => {
        this.setState({open});
    };
    onDock = () => {
        const docked = !this.state.docked;
        this.setState({
            docked,
        });
        if (!docked) {
            this.onOpenChange(false);
        }
    };

    constructor(props) {
        super(props);

        // this.state = {
        //     left: false, right: false, top: false, bottom: false,
        // };
    }

    render() {
        
        // const {
        //     left, right, top, bottom
        // } = this.state;
        return (
            <div className="col-12">
                <div className="drawer-box">

                    <Drawer sidebar={mailFolderListItems} position="top" touch open={this.props.top} children=''
                            onOpenChange={this.props.onOpenChange} style={{overflow: 'auto'}}>
                    </Drawer>

                </div>
            </div>);
    }
}

export default HeaderDrawer


// onClick={() => {
//     this.setState({top: true});


// WEBPACK FOOTER //
// ./components/Drawer/index.js